export default [
  {
    title: 'DEBTIA_CASES',
    icon: 'ServerIcon',
    route: 'cases',
    action: 'read',
    resource: 'Auth',
  },
]
